import { render, staticRenderFns } from "./addAnnounceType.vue?vue&type=template&id=abf450aa&"
import script from "./addAnnounceType.vue?vue&type=script&lang=js&"
export * from "./addAnnounceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abf450aa')) {
      api.createRecord('abf450aa', component.options)
    } else {
      api.reload('abf450aa', component.options)
    }
    module.hot.accept("./addAnnounceType.vue?vue&type=template&id=abf450aa&", function () {
      api.rerender('abf450aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addAnnounceType.vue"
export default component.exports